'use client';

import { IconButton } from '@/features/uiKit/IconButton';
import { Stack } from '@/features/uiKit/Stack';
import { PlayArrowIcon } from '@/features/uiKit/icons';
import { PauseIcon } from '@/features/uiKit/icons';

export const MARIN_IDLE_VIDEO_SRC = '/webcam/marin-idle.webm';
export const MARIN_TALKING_VIDEO_SRC = '/webcam/marin-talking.webm';

export const WebCamButtons = ({
  isPlaying,
  onToggle,
}: {
  isPlaying?: boolean;
  onToggle?: () => void;
}) => {
  return (
    <Stack
      sx={{
        position: 'absolute',
        left: '0px',
        bottom: '0px',
        alignItems: 'center',
        width: '100%',
        padding: isPlaying ? '10px 0 10px 0' : '10px 0 15px 0',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: '10px',
      }}
    >
      <IconButton
        aria-label={isPlaying ? 'Pause' : 'Play'}
        onClick={onToggle}
        data-testid="webcam-play-button"
        data-analytics={isPlaying ? 'webcam-pause' : 'webcam-play'}
        tone={isPlaying ? 'glass' : 'solid'}
        size={isPlaying ? 'small' : 'large'}
      >
        {isPlaying ? (
          <PauseIcon sx={{ fontSize: 20 }} />
        ) : (
          <PlayArrowIcon sx={{ fontSize: 40, transform: 'translateX(0px)' }} />
        )}
      </IconButton>
    </Stack>
  );
};
